import { toneFor } from '../../theme/statusTones';

/**
 * Shared vocabulary for the two task queues.
 *
 * Both /tasks and /tasks/all render the same rows with the same meanings, and
 * the alternative to a shared module is making every column change twice and
 * watching the two pages drift. Waiting time is computed exactly as the
 * report's ageing buckets compute it, so "over 30 days" means the same thing
 * wherever it is shown.
 */

// Solid tones from theme/statusTones.js, shared with every other status label
// in the app. The report's detail table reads the same, through chipFor.
export const chipFor = (status) => toneFor('application', status);

// Statuses whose display name is not just the enum value in title case.
const STATUS_NAMES = {
  pending_contract_upload: 'Prequalified and Pending Contract Upload',
};

export const humaniseStatus = (v) => STATUS_NAMES[v] || String(v || '')
  .split('_').filter(Boolean)
  .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
  .join(' ');

// The threshold the ageing chart calls "Over 30 days". Kept here so the queue
// and the report raise the alarm at the same point.
export const OVERDUE_DAYS = 30;

/**
 * Renders the waiting time the server computed.
 *
 * The number comes from the API rather than being derived here: the row's
 * submissionDate falls back to createdAt, so a draft measured client-side would
 * report the supplier's own delay as ours. Null means never handed to us.
 */
export const formatWaiting = (days) => {
  if (days === null || days === undefined) return '—';
  if (days === 0) return 'today';
  return `${days} day${days === 1 ? '' : 's'}`;
};

export const isOverdue = (days) => typeof days === 'number' && days > OVERDUE_DAYS;
